import * as React from "react";
const SvgFiRrCatalogAlt = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-catalog-alt_svg__a)">
      <path
        fill="#062147"
        d="M22.307.984a4.47 4.47 0 0 0-3.8-.872l-7.702 1.684L8.213.517a5.03 5.03 0 0 0-4.426 0l-1.56.77A3.98 3.98 0 0 0 0 4.87l-.03 16.504c0 1.48.725 2.111 1.156 2.356.228.128.585.27 1.06.27.458 0 1.024-.13 1.689-.529l2.189-1.364 3.096 1.477a7 7 0 0 0 3.627.305l7.107-1.26a4.996 4.996 0 0 0 4.105-4.92V4.502A4.48 4.48 0 0 0 22.307.984M2.83 21.765c-.444.268-.682.248-.72.225-.022-.013-.141-.173-.141-.613l.029-16.504A1.99 1.99 0 0 1 3.113 3.08L4.67 2.31q.161-.08.328-.138v18.241l-2.17 1.352zM7 20.338V2.172q.167.06.328.138L10 3.63v18.133c-.023-.008-3-1.425-3-1.425m15-2.629a3 3 0 0 1-2.46 2.951s-7.395 1.305-7.54 1.32V3.58l6.943-1.518a2.5 2.5 0 0 1 2.115.484c.599.477.94 1.19.94 1.954v13.206zM20 5.241a1 1 0 0 1-.763 1.19s-4.168.902-4.238.902a1 1 0 0 1-.213-1.976l4.023-.879a.997.997 0 0 1 1.19.763m0 4a1 1 0 0 1-.763 1.19s-4.168.902-4.238.902a1 1 0 0 1-.213-1.976l4.023-.879a.996.996 0 0 1 1.19.763m0 4a1 1 0 0 1-.763 1.19s-4.168.902-4.238.902a1 1 0 0 1-.213-1.976l4.023-.879a1 1 0 0 1 1.19.763m-2.012 4.44a1 1 0 0 1-.763 1.19s-2.156.462-2.227.462a1 1 0 0 1-.213-1.976l2.012-.439a.997.997 0 0 1 1.19.763"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-catalog-alt_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCatalogAlt;
